import { getState } from './App';
import { getIntl } from './IntlInstance';
import { getSetting, getUserSetting } from './Settings';

export const thumbnailPlaceholder = '/images/thumbnails/collection.png';

export const getCollectionAvailableFilter = (field) => {
  const state = getState();
  if (state) {
    return state.Collections.availableFilters[field];
  }

  return false;
};

export const getMinCollectionCreatedAt = () => (
  getCollectionAvailableFilter('min_created_at')
);

export const getParentCollection = collection => (
  (collection && collection.ancestors && collection.ancestors.length > 0) ?
    collection.ancestors.slice(-1)[0] : null
);

export const isMyCollectionsPage = () => (
  window.location.pathname === '/collections/my' || window.location.pathname === '/archive/collections/my' ||
  window.location.pathname === '/embed/collections/my' || window.location.pathname === '/embed/archive/collections/my'
);

export const isCollectionsPage = () => (
  window.location.pathname === '/collections' || window.location.pathname === '/archive/collections' ||
  window.location.pathname === '/embed/collections' || window.location.pathname === '/embed/archive/collections'
);

export const isCollectionPage = () => (
  window.location.pathname.indexOf('/collections/') >= 0 || window.location.pathname.indexOf('/archive/collections/') >= 0 ||
  window.location.pathname.indexOf('/embed/collections/') >= 0 || window.location.pathname.indexOf('/embed/archive/collections/') >= 0
);

export const isAllCollectionsPage = () => (
  window.location.pathname === '/collections/all' || window.location.pathname === '/archive/collections/all' ||
  window.location.pathname === '/embed/collections/all' || window.location.pathname === '/embed/archive/collections/all'
);

export const getCurrentCollectionFilters = () => {
  const state = getState();
  if (state) {
    return {
      ...state.Collections.filters,
      collectionUuid: state.Collections.collection?.uuid,
    };
  }

  return false;
};

export const convertParentUuidToNamedUuid = (uuid) => {
  if (uuid === undefined || uuid === null || uuid === 'all') {
    return 'all';
  }

  return uuid;
};

export const getCollectionUrl = (collectionUuid) => {
  if (collectionUuid === '-1') {
    return '/collections/my';
  }

  if (collectionUuid && collectionUuid !== 'all') {
    return `/collections/${collectionUuid}`;
  }

  return '/collections';
};

export const getCollectionAllowedViews = () => (['grid', 'framed', 'list']);

export const getCollectionsView = () => getUserSetting('collections_view') || getSetting('default_collections_view');

export const getLoadedCollectionsLabel = (collections, collectionsTotal) => {
  const intl = getIntl();

  if (collectionsTotal === 0) {
    return null;
  }

  return intl.formatMessage({ defaultMessage: '({collections} of {collectionsTotal})' }, {
    collections: collections.length, collectionsTotal,
  });
};
